const generateYoutubeUrlPrefix = id => `https://www.youtube.com/embed/${id}`;

export default generateYoutubeUrlPrefix;
